<app-navbar title="Rozkłady"></app-navbar>

<app-timetable-list-filters
	userFilters="timetableList"
	[users]="parameters.users"
	[side]="parameters.side"
	(selected)="filtersSelected($event)"
></app-timetable-list-filters>

<app-dynamic-table
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
	module="timetable"
></app-dynamic-table>
